module.exports = __webpack_public_path__ + "static/media/bird-poster.7d5d6851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/bird-poster.jpg
// module id = 242
// module chunks = 1